// Stable, append-only catalogue. Never reuse a code for different content.
export const PAGE_CATALOGUE_VERSION = 1;
export const MARKETING_PAGES = Object.freeze({
  "01": { path: "/", name: "Home" },
  "02": { path: "/financial-advisory", name: "Financial Advisory" },
  "03": { path: "/investing", name: "Investing" },
  "04": { path: "/panda", name: "Panda" },
  "05": { path: "/course/your-roadmap-to-wealth", name: "Your Roadmap to Wealth" },
  "06": { path: "/budgeting-tool", name: "Budgeting Tool" },
  "07": { path: "/team", name: "Team" },
  "08": { path: "/calculators", name: "Calculators" },
  "09": { path: "/our-blog", name: "Our Blog" },
  "0a": { path: "/success-stories", name: "Success Stories" },
  "0b": { path: "/faqs", name: "FAQs" },
});

export function marketingPageCode(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path.startsWith("/calculators/")) return "08";
  return Object.keys(MARKETING_PAGES).find(code => MARKETING_PAGES[code].path === path) || null;
}

export function isMarketingLocation(location) {
  return ["africaspocket.com", "www.africaspocket.com", "staging-ap.webflow.io"].includes(location.hostname);
}
